/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ScanFrameBarcodeQrIcon16Light } from './ScanFrameBarcodeQrIcon16Light';
import { ScanFrameBarcodeQrIcon16Regular } from './ScanFrameBarcodeQrIcon16Regular';
import { ScanFrameBarcodeQrIcon16Solid } from './ScanFrameBarcodeQrIcon16Solid';
import { ScanFrameBarcodeQrIcon20Light } from './ScanFrameBarcodeQrIcon20Light';
import { ScanFrameBarcodeQrIcon20Regular } from './ScanFrameBarcodeQrIcon20Regular';
import { ScanFrameBarcodeQrIcon20Solid } from './ScanFrameBarcodeQrIcon20Solid';
import { ScanFrameBarcodeQrIcon24Regular } from './ScanFrameBarcodeQrIcon24Regular';
import { ScanFrameBarcodeQrIcon24Solid } from './ScanFrameBarcodeQrIcon24Solid';
import { ScanFrameBarcodeQrIcon32Regular } from './ScanFrameBarcodeQrIcon32Regular';
import { ScanFrameBarcodeQrIcon64Regular } from './ScanFrameBarcodeQrIcon64Regular';
var sizes = {
    16: {
        light: ScanFrameBarcodeQrIcon16Light,
        regular: ScanFrameBarcodeQrIcon16Regular,
        solid: ScanFrameBarcodeQrIcon16Solid,
    },
    20: {
        light: ScanFrameBarcodeQrIcon20Light,
        regular: ScanFrameBarcodeQrIcon20Regular,
        solid: ScanFrameBarcodeQrIcon20Solid,
    },
    24: {
        regular: ScanFrameBarcodeQrIcon24Regular,
        solid: ScanFrameBarcodeQrIcon24Solid,
    },
    32: {
        regular: ScanFrameBarcodeQrIcon32Regular,
    },
    64: {
        regular: ScanFrameBarcodeQrIcon64Regular,
    },
};
export var ScanFrameBarcodeQrIcon = forwardRef('ScanFrameBarcodeQrIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
